"use strict";

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-jamstack-pollingapp/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KeyValue = /*#__PURE__*/function () {
  function KeyValue(connection, name) {
    _classCallCheck(this, KeyValue);

    this._connection = connection;
    this.name = name;
  }

  _createClass(KeyValue, [{
    key: "getCollections",
    value: function getCollections() {
      return this._connection.request({
        method: "GET",
        path: "/_api/kv"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getKVCount",
    value: function getKVCount() {
      return this._connection.request({
        method: "GET",
        path: "/_api/kv/".concat(this.name, "/count")
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getKVKeys",
    value: function getKVKeys() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._connection.request({
        method: "GET",
        path: "/_api/kv/".concat(this.name, "/keys"),
        qs: Object.assign({}, opts)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getValueForKey",
    value: function getValueForKey(key) {
      return this._connection.request({
        method: "GET",
        path: "/_api/kv/".concat(this.name, "/value/").concat(key)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createCollection",
    value: function createCollection() {
      var expiration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "POST",
        path: "/_api/kv/".concat(this.name),
        qs: {
          expiration: expiration
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteCollection",
    value: function deleteCollection() {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/kv/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteEntryForKey",
    value: function deleteEntryForKey(key) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/kv/".concat(this.name, "/value/").concat(key)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteEntryForKeys",
    value: function deleteEntryForKeys(keys) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/kv/".concat(this.name, "/values"),
        body: keys
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "insertKVPairs",
    value: function insertKVPairs(keyValuePairs) {
      return this._connection.request({
        method: "PUT",
        path: "/_api/kv/".concat(this.name, "/value"),
        body: keyValuePairs
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return KeyValue;
}();

exports.KeyValue = KeyValue;